import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-access-groups-filters',
  templateUrl: './access-groups-filters.component.html',
  styleUrls: ['./access-groups-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessGroupsFiltersComponent {
  readonly pageFilters = input<{
    search: string;
    updateSearch: (value?: string) => void;
  }>();

  public onSearchSubmitted(value?: string): void {
    this.pageFilters()?.updateSearch(value);
  }
}
